import { useQuery } from "@tanstack/react-query";
import type { PortalFaqItem } from "@colab/shared";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

// GET /api/admin/portal-content/faq — every FAQ item ordered by category +
// position. Active and inactive both surfaced for the admin board.
export function useAdminFaq() {
  return useQuery<PortalFaqItem[], ApiClientError>({
    queryKey: queryKeys.portalContent.faqAdmin(),
    queryFn: () => apiFetch<PortalFaqItem[]>("/admin/portal-content/faq"),
  });
}
